import React from "react";
import { BiSearchAlt } from "react-icons/bi";
import { MdAddCircle } from "react-icons/md";
import { SearchStudent, SearchStudentContainer, StudentHeaderControle } from "../../../students/presantation/studentActionPresentation/studentAction.styels";

import { StudentButton } from "../../../experience/presentation/expereince.list.presentation/experienceListPresentation.styles";
import { CreateStarChartOrgTagFilter } from "./CreateStarChartOrgTagFilter";
import { Column } from "../../../../assets/style/General.style";

interface ExperienceActionPresentationProps {
  onCreateExperience: () => void
  onTerm: (e: React.ChangeEvent<HTMLInputElement>) => void
  listStatus: string
  onExperiences: () => void
  onStudents: () => void
  term: string
}
const CreateStarChartOrgActionPresentation: React.FC<
ExperienceActionPresentationProps
> = ({  onTerm, listStatus, onExperiences, onStudents, term , onCreateExperience }) => {


  return (
    <>
      <Column width={""} minWidth={""} alignment={""} Direction={""}>
          <CreateStarChartOrgTagFilter
            listStatus={listStatus}
            onExperiences={onExperiences}
            onStudents={onStudents}
          
          />
      </Column>
      <StudentHeaderControle style={{ justifyContent:"space-between", marginTop: 20, marginBottom: 30 , marginLeft:0 , padding:"0 15px" , width:"100%"}}>
          { listStatus === 'experiences' ? <>
          
            <SearchStudentContainer>
                <BiSearchAlt
                  spacing={18}
                  style={{ position: 'absolute', top: 11, left: 18 }}
                  color={'#707070'}
                />
                <SearchStudent
                  type="text"

                  value={term === 'null' ? '' : term}
                  placeholder="Search Experience"
                  onChange={onTerm}
                />
          </SearchStudentContainer>

          <StudentButton
            spaceLeft="35px"
            onClick={onCreateExperience}
            style={{ borderRadius: 50, fontSize: 16 , marginRight:10 }}
        
          >
            <MdAddCircle size={30} />
            <span style={{ paddingLeft: 8, fontSize: 19 }}>Add a Card</span>
          </StudentButton>


          </> : <>
          <SearchStudentContainer>
          <BiSearchAlt
            spacing={18}
            style={{ position: 'absolute', top: 11, left: 18 }}
            color={'#707070'}
          />
          <SearchStudent
            type="text"

            value={term === 'null' ? '' : term}
            placeholder="Search Students"
            onChange={onTerm}
          />
        </SearchStudentContainer>



          </>}


      </StudentHeaderControle>
    </>
  )
}

export default CreateStarChartOrgActionPresentation
